import React from "react";

type UnsavedChangesModalProps = {
  onProceed: () => void;
  onCancel: () => void;
  isOpen: boolean;
};

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  onProceed,
  onCancel,
  isOpen,
}) => {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Unsaved Changes
            </h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to leave? You have some unsaved changes.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onCancel();
                }}
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onProceed();
                }}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                id="unsavedModalProceed"
                next-tab=""
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UnsavedChangesModal;
